module.exports = __webpack_public_path__ + "assets/img/changepassword.6f226b8.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/icons/changepassword.png
// module id = edJP
// module chunks = 50